module.exports = "<div class=\"side-menu-header\">\r\n  <rw-retailer-info ng-if=\"!$ctrl.isEmptyRetailerDetails\"\r\n                    retailer=\"$ctrl.retailerDetails\">\r\n  </rw-retailer-info>\r\n\r\n  <!-- ID used as a anchor for dropdown -->\r\n  <div id=\"side-menu-header-selector\"\r\n       class=\"side-menu-header__selector\">\r\n    <rw-location-selector ng-if=\"$ctrl.retailers.length > 1\">\r\n    </rw-location-selector>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/app/components/side-menu/components/side-menu-header/side-menu-header.html
// module id = 2155
// module chunks = 0